export default "__VITE_ASSET__DxJMisl___"